import type { Theme } from "@mui/material/styles"

function getMarginBoxStyles(theme: Theme) {
    return {
        fontFamily: theme.typography.fontFamily,
        fontSize: ".75rem",
        color: theme.palette.tailwind.slate[600],
    }
}

export function getPrintHeaderBoxStyles(theme: Theme) {
    return {
        ...getMarginBoxStyles(theme),
        marginBottom: ".25rem",
        borderBottom: `1px solid ${theme.palette.tailwind.slate[200]}`,
    }
}

export function getPrintFooterBoxStyles(theme: Theme) {
    return {
        ...getMarginBoxStyles(theme),
        marginTop: ".25rem",
        borderTop: `1px solid ${theme.palette.tailwind.slate[200]}`,
    }
}

export function getPrintOrderPageName(orderId: number) {
    return `print-order-${orderId}`
}
